<template>
  <text-field-like
      :value="name"
      :label="label"
      :flat="flat"
      :hide-details="hideDetails"
      :loading="loading"
      :color="color"
      :value-hds-id="id">
    <template #prepend>
      <slot name="prepend"></slot>
      <dictionary-icon
          v-if="dictionaryType"
          :type="dictionaryType"
          :tooltip-placement="tooltipPlacement"
          :tooltip-disabled="tooltipDisabled">
      </dictionary-icon>
    </template>
    <template #default="{value}">
      <slot name="inner-prepend"></slot>
      {{ value }}
      <slot name="inner-append"></slot>
    </template>
    <template #append>
      <slot name="append"></slot>
    </template>
  </text-field-like>
</template>

<script>
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import DictionaryIcon from "@/components/molecules/DictionaryIcon.vue";

export default {
  name: "DictionaryNameField",
  components: {DictionaryIcon, TextFieldLike},
  props: {
    value: {
      type: Object,
      required: false
    },
    label: {
      type: String,
      required: false
    },
    flat: {
      type: Boolean,
      required: false,
      default: false
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      required: false,
    },
    tooltipPlacement: {
      type: String,
    },
    tooltipDisabled: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    id() {
      return this.value?.id;
    },
    name() {
      return this.value?.name;
    },
    dictionaryType() {
      return this.value?.dictionaryType;
    },
  },
}
</script>

<style scoped>
.v-icon {
  position: relative;
  top: 3px;
}
</style>
